export default __webpack_public_path__ + "static/media/story-3.8a185bd8.png";